import { Component, OnInit, SkipSelf, ChangeDetectorRef } from "@angular/core";
import { genId } from "../../../core/services/genId";
import { Question, QuestionKind, Rule } from "../../../common/models/flow.dto";
import { StateBuilderService } from "../../services/state-builder.service";
import { SidePanelBase } from "../../../common/components/side-panel-base.class";
import { getReviewFormEditableDefault } from "../../../form-controls/components/base-control/base-control.component";
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../../common/utils/froala.utils';

@Component({
    selector: "state-builder-settings",
    templateUrl: "./state-builder-settings.component.html",
    standalone: false
})

export class StateBuilderSettingsComponent extends SidePanelBase implements OnInit {
    static componentName = "StateSettingsComponent";

    public displayConfiguration: string = null;
    public currentQuestion: Question;

    get enableReviewEditing(): boolean {
        if (this.currentQuestion.config.enableEditing == null) {
            this.currentQuestion.config.enableEditing =
                getReviewFormEditableDefault(this.currentQuestion.type);
        }
        return this.currentQuestion.config.enableEditing;
    }

    set enableReviewEditing(value: boolean) {
        this.currentQuestion.config.enableEditing = value;
    }

    get requireNotes(): boolean {
        if (this.currentQuestion.config.requireNotes == null) {
            this.currentQuestion.config.requireNotes = false;
        }
        return this.currentQuestion.config.requireNotes;
    }

    set requireNotes(value: boolean) {
        this.currentQuestion.config.requireNotes = value;
    }



    helpTextOptions = [
        ["bold", "italic", "link"],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }]
    ];

    //TODO: this needs to be filterd dynamically, based on the type of control dropped into form
    questionKindKeys;

    private _froalaOptions: any = null;
    get froalaOptions(): Object {
        if (!this._froalaOptions) {
            this._froalaOptions = applyFroalaAriaFix({
                heightMax: 500,
                height: 500,
                heightMin: 150,
                key: this.editorKey,
                toolbarButtons: ["fullscreen", "html", "|", "undo", "redo", "|", "bold", "italic", "underline", 'strikeThrough', "|", "formatOL", "formatUL", "|", "align", "fontSize", "paragraphFormat", "insertLink", "|", "outdent", "indent", "clearFormatting", "insertTable", "color"]
            });
        }
        return this._froalaOptions;
    }

    constructor(
        @SkipSelf() public changeDetectorRef: ChangeDetectorRef,
        public _stateBuilderService: StateBuilderService) {
        super();

        //convert enum to value pairs
        this.questionKindKeys = Object.keys(QuestionKind).filter(a => a.match(/^\D/)).map(name => ({ name, value: QuestionKind[name] as number }));
    }

    ngOnInit() {
        if (this.componentData.currentQuestion) {
            this.currentQuestion = this.componentData.currentQuestion;
        } else {
            this.currentQuestion = {
                key: "",
                label: "",
                helpText: "",
                config: "",
                type: QuestionKind.Checkbox,
                contextTarget: "",
                enabledRule: null,
                validationRules: [],
                visibleRule: null,
                changeRules: [],
                flexGrow: -1,
                //files: [],
                notes: [],
                defaultValue: undefined
            }
        }

        this.getConfigurationType();
    }

    public getConfigurationType() {
        let config = this._stateBuilderService.getConfigurationType(this.currentQuestion.type as QuestionKind);
        this.displayConfiguration = config.display + 'displayconfig'
    }

    updateEnabledRule(rule: Rule): void {
        if (!rule.expression || !rule.parseTree)
            return;

        if (!this.currentQuestion.enabledRule) {
            this.currentQuestion.enabledRule = {
                name: "enabled",
                ruleId: genId(),
            } as Rule;
        }

        this.currentQuestion.enabledRule.expression = rule.expression;
        this.currentQuestion.enabledRule.parseTree = rule.parseTree;
    }

    updateVisibleRule(rule: Rule): void {
        if (!rule.expression || !rule.parseTree)
            return;

        if (!this.currentQuestion.visibleRule) {
            this.currentQuestion.visibleRule = {
                name: "visible",
                ruleId: genId(),
            } as Rule;
        }

        this.currentQuestion.visibleRule.expression = rule.expression;
        this.currentQuestion.visibleRule.parseTree = rule.parseTree;
    }

    onChange() {
        this.currentQuestion.label = stripFroalaWatermark(this.currentQuestion.label);
        this.currentQuestion.helpText = stripFroalaWatermark(this.currentQuestion.helpText);
        this.changeDetectorRef.detectChanges();
    }
}
